<div 
    class="container-item" 
    [class.disabled]="disabled()"
    [raTooltip]="{ text: tooltip() || text(), position: 'left' }">
            
    <!-- Left -->
    <div class="container-left">
        <!-- Ornamento: quem recebe o clique é a linha inteira -->
        <ra-square-icon
            [icon]="icon()"
            [interactive]="false"
        />

        <p>{{ text() }}</p>
    </div>

    <!-- Right -->
    <ra-icon icon="arrow-right" varColor="currentColor" [size]="20" />
</div>